import { render } from "./AccountHeader.vue?vue&type=template&id=1807233c"
import script from "./AccountHeader.vue?vue&type=script&lang=js"
export * from "./AccountHeader.vue?vue&type=script&lang=js"

import "./AccountHeader.vue?vue&type=style&index=0&id=1807233c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__